import { TherapistSpecialtyModel } from '@/modules/schedule/domain/models/TherapistSpecialtieModel'

import { axios, Response } from '../index'

export const getTherapistForSpecialty = (
  specialtyId: string
): Response<TherapistSpecialtyModel> => {
  return axios.get(`/v1/therapists-specialties/${specialtyId}`)
}
